import { Recipe, RecipeComponent, Store } from '../../../app/services/api/generated';
import { createContext, useContext, useState, useMemo } from 'react';

export interface FormState {
  selectedEntityType: number;
  description: string;
  primaryUOM?: string;
  weight?: number;
  unitCostPrice?: number;
  uomConversion?: number;
  isAllStores?: boolean;
  selectedStores?: Store[];
  selectedCategory?: string;
  selectedType?: string;
  itemNumber: string;
  recipeComponents: RecipeComponent[];
  updateForStore?: boolean;
}

export interface RecipeDialogSeed {
  recipe: Recipe | null;
  entityType: number;
}

interface RecipeDialogContextProps {
  showRecipeDialog: boolean;
  dialogSeed: RecipeDialogSeed;
  openRecipeDialog: (seed: RecipeDialogSeed) => void;
  closeRecipeDialog: () => void;
}

const defaultSeed: RecipeDialogSeed = { recipe: null, entityType: 1 };

const initialContextState: RecipeDialogContextProps = {
  showRecipeDialog: false,
  dialogSeed: defaultSeed,
  openRecipeDialog: () => {},
  closeRecipeDialog: () => {},
};

const RecipeDialogContext = createContext<RecipeDialogContextProps>(initialContextState);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RecipeDialogProvider = ({ children }: any) => {
  const [showRecipeDialog, setShowRecipeDialog] = useState<boolean>(false);
  const [dialogSeed, setDialogSeed] = useState<RecipeDialogSeed>(defaultSeed);

  const contextValue = useMemo(() => {
    const openRecipeDialog = (seed: RecipeDialogSeed) => {
      setDialogSeed(seed);
      setShowRecipeDialog(true);
    };

    const closeRecipeDialog = () => {
      setShowRecipeDialog(false);
    };

    return {
      showRecipeDialog,
      dialogSeed,
      openRecipeDialog,
      closeRecipeDialog,
    };
  }, [showRecipeDialog, dialogSeed]);

  return (
    <RecipeDialogContext.Provider value={contextValue}>{children}</RecipeDialogContext.Provider>
  );
};

const useRecipeDialog = () => {
  const context = useContext(RecipeDialogContext);

  return context;
};

export { RecipeDialogProvider, useRecipeDialog };
